import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
// `$icon()` requires string literals at build time (AST scanning), so every
// icon name a skill's `icon` frontmatter may carry must appear here.
const SKILL_ICONS = {
    book: $icon('book'),
    telescope: $icon('telescope'),
    target: $icon('target'),
    'clipboard-list': $icon('clipboard-list'),
    'clipboard-check': $icon('clipboard-check'),
    'adjustments-horizontal': $icon('adjustments-horizontal'),
    gavel: $icon('gavel'),
    users: $icon('users'),
    plus: $icon('plus'),
    settings: $icon('settings'),
    speakerphone: $icon('speakerphone'),
    spy: $icon('spy'),
    search: $icon('search'),
    click: $icon('click'),
    plug: $icon('plug'),
    'file-text': $icon('file-text'),
};
const DEFAULT_SKILL_ICON = $icon('file-text');
export function lookupSkillIcon(iconName) {
    if (!iconName || !Object.hasOwn(SKILL_ICONS, iconName)) {
        return undefined;
    }
    return SKILL_ICONS[iconName];
}
export function resolveSkillIcon(iconName) {
    return lookupSkillIcon(iconName) ?? DEFAULT_SKILL_ICON;
}
//# sourceMappingURL=skillIconRegistry.js.map